import { render } from "./ButtonModal.vue?vue&type=template&id=9c1db646"
import script from "./ButtonModal.vue?vue&type=script&lang=js"
export * from "./ButtonModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__